import { Link } from "react-router-dom";
import { staff } from "../domain/data";
import { useForms } from "../state/forms";
import { PrototypeBanner, StaffNav } from "../components/ui";

export function StaffForms() {
  const { forms, submissionsFor } = useForms();

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <StaffNav />
        <p className="meta">
          Staff · {staff.given} {staff.family} · forms
        </p>
        <h1>School-year forms</h1>
        <p className="lede">
          Filter by school year, then open a form to slice by age, district, and
          date. Import students already registered this year so they do not fill
          the form again.
        </p>

        <div className="actions actions-split" style={{ marginTop: 0, marginBottom: "1rem" }}>
          <div className="actions-group">
            <Link className="btn" to="/staff/students/upload">
              Import Students
            </Link>
          </div>
          <div className="actions-group">
            <Link className="btn" to="/staff/forms/new">
              New school year
            </Link>
          </div>
        </div>

        <ul className="list-plain">
          {forms.map((form) => {
            const count = submissionsFor(form.id).length;
            return (
              <li key={form.id}>
                <div className="row">
                  <Link to={`/staff/forms/${form.id}`}>
                    <div className="title">
                      <strong>{form.name}</strong>
                    </div>
                    <div className="anno">
                      Opened {form.openedLabel}
                      {form.archivedLabel
                        ? ` · archived ${form.archivedLabel}`
                        : ""}
                    </div>
                    <div className="anno">{count} responses saved</div>
                  </Link>
                  <Link
                    className={form.status === "open" ? "btn" : "btn ghost"}
                    to={`/staff/forms/${form.id}/edit`}
                  >
                    {form.status === "open" ? "Design form" : "View design"}
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      </main>
    </div>
  );
}
